import PopupMsgIcon from "src/assets/svg/popup-msg-icon"
import { RiCloseFill } from "react-icons/ri"
import { Button, FlexRow } from "src/style"

export const CenterPopupHeader: React.FC<any> = ({close, icon}) => {
    return (
        <FlexRow justifyContent="space-between" bottomPadding='1'>
            { icon || <PopupMsgIcon className='icon-component' />}
            { close ?
                <Button 
                    titleSize="2" fontWeight="500"
                    width='3.4' shadow='none'
                    height='3.4'
                    radius='0.6'
                    bgColor='#ffffff'
                    hoverBgColor='#FEF3F2'
                    borderColor='none'
                    color='#000000'
                    hoverColor='#B42318'
                    onClick={close}
                >
                    <RiCloseFill style={{fontSize: '2.3rem'}} />
                </Button> 
                : null
            }
        </FlexRow>
    )
}